"use client";

import { cn } from "@/lib/utils";

interface SignInBadgeProps {
  onClick: (callback?: () => Promise<void>) => void;
  className?: string;
  size?: "default" | "lg";
}

export function SignInBadge({
  onClick,
  className,
  size = "default",
}: SignInBadgeProps) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className={cn(
        // Layout & sizing
        "relative rounded-xl",
        size === "lg" ? "px-8 py-3" : "px-4 py-1.5",
        // Glass effect from game page v3 with gold accent
        "glass-border accent-border animated-border",
        "backdrop-blur-md accent-background",
        // Typography
        "text-white font-semibold text-sm",
        // Interactions & hover glow
        "transition-all duration-200 ease-out",
        "hover-glow-gold",
        className,
      )}
      // Set gold accent color (RGB: 253, 209, 66)
      style={{ "--accent-colour": "253, 209, 66" } as React.CSSProperties}
    >
      Sign In
    </button>
  );
}
